import CryptoJS from 'crypto-js'

// 默认的 KEY 与 iv 如果没有给
const keyStr = CryptoJS.enc.Utf8.parse('dmsaiyqnrqlj11qa')
const ivStr = CryptoJS.enc.Utf8.parse('sndlarjqinqkjsli')

/**
 * AES加密 ：字符串 key iv  返回base64
 */
export function Encrypt (word) {
  let srcs = CryptoJS.enc.Utf8.parse(word)
  var encrypted = CryptoJS.AES.encrypt(srcs, keyStr, {
    iv: ivStr,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  // console.log("-=-=-=-", encrypted.ciphertext)
  return CryptoJS.enc.Base64.stringify(encrypted.ciphertext)
}

/**
 * AES 解密 ：字符串 key iv  返回base64
 *
 */
export function Decrypt (word) {
  var decrypt = CryptoJS.AES.decrypt(word, keyStr, {
    iv: ivStr,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })

  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8)
  return decryptedStr.toString()
}



// WEBPACK FOOTER //
// ./src/api/ucrypto.js